<template>
    <div>
    <loader/>
    <!--
    <Carousel/>
      -->
      <div class="container-fluid">
    <br>
        <b-row>
          <b-col md>
            <div>
             <h1 class="titlequestion"> {{$t('fleet.title')}}</h1>
            </div>
          </b-col>
          <b-col md class="d-none d-sm-none d-md-block">
            <div class="" style="position:absolute;right:20px;">
              <router-link :to="{ name: 'Home'}" style="text-decoration:none">
                <b-button 
                block 
                squared 
                class="buttonreserve text-uppercase"
                > {{ back }} {{$t('buttons_label.return_back')}}  
                </b-button>
              </router-link>
            </div>
          </b-col>
        </b-row>
        <br>
        <!-- filter mobile ----------------------------------------------->
        <div class=" d-xl-none">
          <div style="float:right;">
          <img style="height:16px; width:18px;" src="/img/iconfilter.svg">
          <a v-b-toggle.collapse-filtercar 
          class="cardetailtext m-2"
          >{{$t('fleet.fil0')}}</a>
          
          </div>
          <br><br>
          <b-collapse id="collapse-filtercar" class="">
          <b-row>
            <b-col xl>
            <b-card
              border-variant="secondary"
              :header="$t('fleet.fil1')"
              header-border-variant="secondary"
              align="left"
              class="rounded-0"
              style=""
            >
              <b-card-text>
                <p style="text-align:left; ">{{$t('fleet.fil2')}} <!-- <span style="float:right;">Total desde</span> --></p>
              </b-card-text>
              <b-row>
                <b-col>
                  <!--  -->
                  <div class="container">
                     <label class="customcheck">{{$t('fleet.fil3')}}
                       <input type="checkbox" v-model="selected" value="Autos" checked="checked">
                       <span class="checkmark"></span>
                     </label>
                     <label class="customcheck">{{$t('fleet.fil4')}}
                       <input type="checkbox" v-model="selected" value="SUV">
                       <span class="checkmark"></span>
                     </label>
                     <label class="customcheck">{{$t('fleet.fil5')}}
                       <input type="checkbox" v-model="selected" value="Van">
                       <span class="checkmark"></span>
                     </label>
                     <label class="customcheck">{{$t('fleet.fil6')}}
                       <input type="checkbox" v-model="selected" value="Comercial">
                       <span class="checkmark"></span>
                     </label>
                     <label class="customcheck">Promo
                       <input type="checkbox" v-model="selected" value="Promo">
                       <span class="checkmark"></span>
                     </label>
                  </div>
                </b-col>
                <!-- <b-col cols="4">
                  <span class="">US$ 100</span><br><br>
                  <span class="">US$ 110</span><br><br>
                  <span class="">US$ 115</span><br><br>
                  <span class="">US$ 120</span>
                </b-col> -->
              </b-row>
            </b-card>
            </b-col>
            <!-- ///// -->
            <b-col xl>
            <b-card
              border-variant="secondary"
              align="left"
              class="rounded-0 border-top-0"
              style=""
            >
              <b-card-text>
                <p style="text-align:left;" class="filtertitle">{{$t('fleet.fil7')}} <!-- <span style="float:right;">Total desde</span> --></p>
              </b-card-text>
              <b-row>
                <b-col>
                  <!--  -->
                  <div class="container">
                     <label class="customcheck">{{$t('fleet.fil8')}}
                       <input type="checkbox" v-model="category" value="Económico">
                       <span class="checkmark"></span>
                     </label>
                     <label class="customcheck">{{$t('fleet.fil9')}}
                       <input type="checkbox" v-model="category" value="Intermedio">
                       <span class="checkmark"></span>
                     </label>
                     <label class="customcheck">{{$t('fleet.fil10')}}
                       <input type="checkbox" v-model="category" value="Grande">
                       <span class="checkmark"></span>
                     </label>
                     <label class="customcheck">{{$t('fleet.fil11')}}
                       <input type="checkbox" v-model="category" value="Lujo">
                       <span class="checkmark"></span>
                     </label>
                     <label class="customcheck">{{$t('fleet.fil12')}}
                       <input type="checkbox" v-model="category" value="Premium">
                       <span class="checkmark"></span>
                     </label>
                  </div>
                </b-col>
                <!-- <b-col cols="4">
                  <span class="">US$ 100</span><br><br>
                  <span class="">US$ 110</span><br><br>
                  <span class="">US$ 115</span><br><br>
                  <span class="">US$ 120</span>
                </b-col> -->
              </b-row>
            </b-card>
          </b-col>
          </b-row>
          </b-collapse>
        </div>
        <div class="mt-3 ">
        <br>
        <b-row>
          <!-- ///// START FILTERS ///////   -->
          <b-col cols="3" class="d-none d-xl-block">
            <b-card
              border-variant="secondary"
              :header="$t('fleet.fil1')"
              header-border-variant="secondary"
              align="left"
              class="rounded-0 ml-3"
              style="background:#f3f3f3"
            >
              <b-card-text>
                <p style="text-align:left; ">{{$t('fleet.fil2')}} <!-- <span style="float:right;">Total desde</span> --></p>
              </b-card-text>
              <b-row>
                <b-col>
                  <!--  -->
                  <div class="container">
                     <label class="customcheck">{{$t('fleet.fil3')}}
                       <input type="checkbox" v-model="selected" value="Autos" checked="checked">
                       <span class="checkmark"></span>
                     </label>
                     <label class="customcheck">{{$t('fleet.fil4')}}
                       <input type="checkbox" v-model="selected" value="SUV">
                       <span class="checkmark"></span>
                     </label>
                     <label class="customcheck">{{$t('fleet.fil5')}}
                       <input type="checkbox" v-model="selected" value="Van">
                       <span class="checkmark"></span>
                     </label>
                     <label class="customcheck">{{$t('fleet.fil6')}}
                       <input type="checkbox" v-model="selected" value="Comercial">
                       <span class="checkmark"></span>
                     </label>
                     <label class="customcheck">Promo
                       <input type="checkbox" v-model="selected" value="Promo">
                       <span class="checkmark"></span>
                     </label>
                  </div>
                </b-col>
                <!-- <b-col cols="4">
                  <span class="">US$ 100</span><br><br>
                  <span class="">US$ 110</span><br><br>
                  <span class="">US$ 115</span><br><br>
                  <span class="">US$ 120</span>
                </b-col> -->
              </b-row>
            </b-card>
            <!-- ///// -->
            <b-card
              border-variant="secondary"
              align="left"
              class="rounded-0 ml-3 border-top-0"
              style="background:#f3f3f3"
            >
              <b-card-text>
                <p style="text-align:left;" class="filtertitle">{{$t('fleet.fil7')}} <!-- <span style="float:right;">Total desde</span> --></p>
              </b-card-text>
              <b-row>
                <b-col>
                  <!--  -->
                  <div class="container">
                     <label class="customcheck">{{$t('fleet.fil8')}}
                       <input type="checkbox" v-model="category" value="Económico">
                       <span class="checkmark"></span>
                     </label>
                     <label class="customcheck">{{$t('fleet.fil9')}}
                       <input type="checkbox" v-model="category" value="Intermedio">
                       <span class="checkmark"></span>
                     </label>
                     <label class="customcheck">{{$t('fleet.fil10')}}
                       <input type="checkbox" v-model="category" value="Grande">
                       <span class="checkmark"></span>
                     </label>
                     <label class="customcheck">{{$t('fleet.fil11')}}
                       <input type="checkbox" v-model="category" value="Lujo">
                       <span class="checkmark"></span>
                     </label>
                     <label class="customcheck">{{$t('fleet.fil12')}}
                       <input type="checkbox" v-model="category" value="Premium">
                       <span class="checkmark"></span>
                     </label>
                  </div>
                </b-col>
                <!-- <b-col cols="4">
                  <span class="">US$ 100</span><br><br>
                  <span class="">US$ 110</span><br><br>
                  <span class="">US$ 115</span><br><br>
                  <span class="">US$ 120</span>
                </b-col> -->
              </b-row>
            </b-card>
          </b-col>
          <b-col cols>
            <div class="container-fluid" style="border-top: solid 3px rgb(0, 0, 0) !important;">
          
              <div  
              style="border-bottom: solid 2px #b8b8b8 !important;"
              :key="item.id"
              v-for="(item, index) in precalculo"
              v-show="(allselected.includes(item[0].categoria_filtro)) || (selected.includes(item[0].categoria_filtro) && category.includes(item[0].categoria_sdipp)) || selected.length == 0 && category.includes(item[0].categoria_sdipp) || (category.length == 0 && selected.includes(item[0].categoria_filtro)) || (selected.includes('Promo') && item[0].tspecial.valor > 0)"
              >
              
              <!-- start web version -->
              <div class="d-none d-sm-none d-md-none d-lg-block reservas_imagen">
                <b-row>
                  <b-col cols="3">
                    <img v-if="item[0].vehiculo_restriccion>0" class="imagen_restriccion" :src="item[0].url_imagen"/>
                    <img v-else class="" :src="item[0].url_imagen"/>
                    <div v-if="item[0].vehiculo_restriccion>0" class="reservas_modelo_restriccion">{{$t('fleet.unavailable')}}</div>
                  </b-col>
                  <b-col class="mt-3" md="5">
                    <!-- category translate if -->
                    <h2 v-if="$i18n.locale==='en'" class="cartitle mb-2">{{item[0].titulo_vehiculo_en}}</h2>
                    <h2 v-else class="cartitle mb-2">{{item[0].titulo_vehiculo}}</h2>

                     <p class="carsubtitle">{{item[0].marca}} {{item[0].modelo}} {{$t('fleet.fl1')}}</p>
                     <p v-if="$i18n.locale === 'es'" class="carsubtitle">{{item[0].descripcion_corta}}</p>
                     <p v-else class="carsubtitle">{{item[0].descripcion_corta_en}}</p>
                     <div class="carsubtitle">
                       <span class="mr-3"><img class="caricons" src="/img/transmision.png" > {{item[0].transmision}}</span> 
                       <span class="mr-3"><img class="caricons" src="/img/people.png" > {{item[0].capacidad}} {{$t('fleet.fl2')}}</span> 
                       <span class="mr-3" v-if="item[0].maletas !== '0'"><img class="caricons" src="/img/bags.png" > {{item[0].maletas}} {{$t('fleet.fl3')}}</span>
                     </div>
                     <div class="cardetailtext mt-2 mb-4">
                       <p class="cardetailtext" v-b-toggle="'collapsecar'+item[0].id">
                       <img src="/img/arrowdown.png" class="mr-2">
                       {{$t('fleet.fl4')}}
                       </p>
                     </div>
                  </b-col>
                  <b-col md="4">
                    <div class="mt-2 border-bottom border-secondary">
                      <span class="cartitletext">{{$t('fleet.fl5')}}</span>
                    </div>
                     <b-row>
                       <b-col class="mt-2 border-right border-secondary">
                         <div class="text-center">
                          <span style="padding-top:-10px">US$</span>
                          <span class="cartitle">{{parseFloat(item.detalle.tarifa_ofrecida).toFixed(2)}}</span>
                          <!-- <span class="">.00</span> -->
                          <br>
                          <span class="carsubtitle">{{$t('fleet.fl6')}}</span>
                         </div>
                       </b-col>
                       <b-col class="mt-2">
                          <div class="text-center">
                          <span style="padding-top:-10px">US$</span>
                          <span class="cartitle">{{parseFloat(item.detalle.total).toFixed(2)}}</span>
                          <!-- <span class="">.--</span> -->
                          <br>
                          <span class="carsubtitle">total:</span>
                         </div>
                       </b-col>
                       <div v-if="item[0].vehiculo_restriccion==0">
                          <b-button 
                          block 
                          squared
                          :disabled="item[0].vehiculo_restriccion>0"
                          class="virgil button mt-2 ml-3 mr-3 text-uppercase" 
                          @click="select_Car_gtm(item[0].modelo, item[0].vehiculo_id, item[0].marca, item[0].categoria_sdipp, item[0].valor, index, item[0].transmision, item[0].capacidad, item[0].titulo_vehiculo), tercerPaso(item[0].vehiculo_id)"
                          >{{$t('buttons_label.reserve')}}</b-button>
                       </div>
                       <!--boton promocion-->
                       <b-button 
                       v-if="item[0].tspecial.valor > 0"
                       block 
                       squared 
                       class="button mb-2 mt-2 ml-3 mr-3"
                       :to="'promocion-especial/' + item[0].vehiculo_id +'/'+ item[0].marca +'/'+item[0].modelo"
                       >PROMO</b-button>

                       <div v-if="item[0].vehiculo_restriccion==1" class="col contenedor_disclaimer">
                          <div class="reservas_texto_contactar">{{$t('fleet.contacte_reserva')}}</div>
                          <div class="numreservas">
                            <a href="tel:+5072757199" ><img src="/img/tel.png" />
                              <div class="reservas_contacto">+507 275-7199</div></a>
                          </div>

                          <div class="numwhatsapp">
                            <a href="//api.whatsapp.com/send?phone=50769985284&text=Saludos, me gustaría conocer la disponibilidad del auto + item[0].modelo" ><img src="/img/whatsapp.png" />
                              <div class="reservas_contacto">+507 6998-5284</div>
                            </a>
                          </div>
                          <div class="reservas_email">
                            <a href="#"><img src="/img/icono-email.png" />
                              <div class="reservas_contacto">reservas@enterprisepanama.com</div>
                            </a>
                          </div>

                       </div>


                     </b-row>
                  </b-col>
                </b-row>
                <b-collapse 
                v-bind:id="'collapsecar'+item[0].id"
                class="carcard"
                style=""
                >
                  <b-card class="rounded-0" style="background:#f3f3f3">
                   <b-row>
                     <b-col>
                       
                        <span v-if="$i18n.locale==='es'" class="mr-1 carsubtitle">· {{item[0].descripcion_larga}} </span> 
                        <span v-else class="mr-1 carsubtitle">· {{item[0].descripcion_larga_en}} </span>
                        <br><br>
                        <h3 class="cartitletext">{{$t('fleet.fl7')}}</h3>
                        <span v-if="$i18n.locale==='es'" class="mr-1 carsubtitle">· {{item[0].equipamiento}} </span> 
                        <span v-else class="mr-1 carsubtitle">· {{item[0].equipamiento_en}} </span> 
                        <!--  <span class="mr-1 carsubtitle">· Automático </span> 
                         <span class="mr-1 carsubtitle">· Aire acondicionado</span>  -->
                     </b-col>
                     <b-col cols="5">
                       <div class="container-fluid">
                        <h3 class="cartitletext">{{$t('fleet.fl8')}}</h3>
                        <p style="text-align:left;">
                          
                          <span>Tarifa diaria</span>
                          <span style="float:right;" v-if="item.reserva.paquete === 'Fin de Semana' || item.reserva.paquete === '3 Days' || item.reserva.paquete === '4 Days'">
                            
                            US$ {{ paquetes(item.detalle.tarifa, item.reserva.cant_dias) }}
                          </span>
                          <span v-else style="float:right;">
                            {{ parseFloat(item.detalle.tarifa).toFixed(2) }}
                          </span>
                        </p>
                          <div v-if="item.reserva.paquete === 'Fin de Semana' || item.reserva.paquete === '3 Days' || item.reserva.paquete === '4 Days'">
                            
                            <span>Paquete {{item.reserva.paquete}}</span><br>
                            <span>Incluye Coberturas Básicas</span><br>
                            <span>CDW: Cobertura Parcial de Colisión y Robo</span><br>
                            <span>DAT: Cobertura de Daños a Terceros </span>
                          </div>
                          
                          <div v-else-if="item.reserva.paquete === 'Two, One Free'">
                              
                              <span>Paquete Two, One Free</span><br>
                              <span>Incluye coberturas básicas y Exoneración del Deducible. </span>
                          </div>
                          <div v-else>
                          </div>
                        <br>

                        <h3 class="cartitletext">{{$t('fleet.fl9')}}</h3>
                        
                        <b-row v-if="item.detalle.cob_obligatoria != null">
                          <b-col  cols="8" >
                            <span class="float-left" v-if="$i18n.locale==='es'" v-show="item.detalle.cob_obligatoria.monto[0] > 0">{{item.detalle.cob_obligatoria.nombre[0]}}</span>
                            <span class="float-left" v-else v-show="item.detalle.cob_obligatoria.monto[0] > 0">Loss damage partial waiver</span>
                          </b-col>
                          <b-col>
                            <span class="float-right" v-show="item.detalle.cob_obligatoria.monto[0] > 0">US$ {{parseFloat(item.detalle.cob_obligatoria.monto[0]).toFixed(2)}}</span><br>
                          </b-col>
                        </b-row>

                        <b-row v-if="item.detalle.cob_obligatoria != null">
                          <b-col  cols="8" >
                            <span class="float-left" v-if="$i18n.locale==='es'" v-show="item.detalle.cob_obligatoria.monto[1] > 0">{{item.detalle.cob_obligatoria.nombre[1]}}</span>
                            <span class="float-left" v-else v-show="item.detalle.cob_obligatoria.monto[1] > 0">Third parties damage (mandatory)</span>
                          </b-col>
                          <b-col>
                            <span class="float-right" v-show="item.detalle.cob_obligatoria.monto[1] > 0">US$ {{parseFloat(item.detalle.cob_obligatoria.monto[1]).toFixed(2)}}</span>
                          </b-col>
                        </b-row>

                        <b-row>
                          <b-col  cols="8"  v-if="item.detalle.apo_fee > 0">
                            <span>{{$t('fleet.fl10')}}</span>
                          </b-col>
                          <b-col>
                            <span style="float:right;">US$ {{parseFloat(item.detalle.apo_fee).toFixed(2)}} </span>
                          </b-col>
                        </b-row>

                        <b-row>
                          <b-col  cols="8" >
                            <span>Subtotal</span>
                          </b-col>
                          <b-col>
                            <span style="float:right;">US$ {{parseFloat(item.detalle.subtotal).toFixed(2)}} </span>
                          </b-col>
                        </b-row>

                        <b-row>
                          <b-col  cols="8" >
                            <span>{{$t('fleet.fl11')}}</span>
                          </b-col>
                          <b-col>
                            <span style="float:right;">US$ {{parseFloat(item.detalle.itbm).toFixed(2)}} </span>
                          </b-col>
                        </b-row>
                        <hr>
                        <b-row>
                          <b-col  cols="8" >
                            <span>{{$t('fleet.fl12')}}</span>
                          </b-col>
                          <b-col>
                            <span style="float:right;">US$ {{parseFloat(item.detalle.total).toFixed(2)}} </span>
                          </b-col>
                        </b-row>

                       
                        </div>
                     </b-col>
                   </b-row>
                   <!-- <div class="carsmalltext mt-3">
                     Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi, nesciunt eligendi maxime repellendus nostrum velit maiores laudantium eius ex, explicabo enim fugiat, obcaecati eos? Alias exercitationem blanditiis voluptatibus iste quae.
                   </div> -->
                  </b-card>
                </b-collapse>
                </div>
                <!-- ///////////////////////////////////////////// -->
                <!-- ///////////// START MOBILE VERSION ////////// -->
                <div class="d-lg-none d-xl-none">
                <b-row>
                  <b-col class="mt-3" cols="7">
                     <div>
                    <div v-if="$i18n.locale==='en'">
                      <h2 v-if="item[0].categoria_sdipp==='Económico'" class="cartitle mb-2">Economic</h2>
                      <h2 v-else-if="item[0].categoria_sdipp==='Intermedio'" class="cartitle mb-2">Intermediate</h2>
                      <h2 v-else-if="item[0].categoria_sdipp==='Premium'" class="cartitle mb-2">Fullsize</h2>
                      <h2 v-else-if="item[0].categoria_sdipp==='Lujo'" class="cartitle mb-2">Luxury</h2>
                      <h2 v-else-if="item[0].categoria_sdipp==='Grande'" class="cartitle mb-2">Premium</h2>
                    </div>
                    <h2 v-else class="cartitle mb-2">{{item[0].categoria_sdipp}}</h2>

                       <p class="carsubtitle">{{item[0].marca}} {{item[0].modelo}} {{$t('fleet.fl1')}}</p>
                     </div>
                     <div class="carsubtitle">
                       <span class="mr-3"><img class="caricons" src="/img/transmision.png" > {{item[0].transmision}}</span> 
                       <span class="mr-3"><img class="caricons" src="/img/people.png" > {{item[0].capacidad}} {{$t('fleet.fl2')}}</span> 
                       <span class="mr-3" v-if="item[0].maletas !== '0'"><img class="caricons" src="/img/bags.png" > {{item[0].maletas}} {{$t('fleet.fl3')}}</span>
                     </div>
                  </b-col>
                  <b-col cols="5">
                    <img 
                    class="carsimg" 
                    :src="item[0].url_imagen"/>
                  </b-col>
                </b-row>
                <br>
                <b-row>
                  <b-col >
                    <div class="mt-2 border-bottom border-secondary">
                      <span class="cartitletext">{{$t('fleet.fl5')}}</span>
                    </div>
                     <b-row>
                       <b-col class="mt-2 border-right border-secondary">
                         <div class="text-center">
                          <span style="padding-top:-10px">US$</span>
                          <span class="cartitle">{{parseFloat(item.detalle.tarifa_ofrecida).toFixed(2)}}</span>
                          <!-- <span class="">.00</span> -->
                          <br>
                          <span class="carsubtitle">{{$t('fleet.fl6')}}</span>
                         </div>
                       </b-col>
                       <b-col class="mt-2">
                          <div class="text-center">
                          <span style="padding-top:-10px">US$</span>
                          <span class="cartitle">{{parseFloat(item.detalle.total).toFixed(2)}}</span>
                          <!-- <span class="">.--</span> -->
                          <br>
                          <span class="carsubtitle">total:</span>
                         </div>
                       </b-col>
                       <b-button 
                       block 
                       squared 
                       class="button mt-2 ml-3 mr-3 text-uppercase" 
                       @click="select_Car_gtm(item[0].modelo, item[0].vehiculo_id, item[0].marca, item[0].titulo_vehiculo, item[0].valor, index, item[0].transmision, item[0].capacidad, item[0].titulo_vehiculo), tercerPaso(item[0].vehiculo_id)"
                       >{{$t('buttons_label.reserve')}}</b-button>
                       <!--boton promocion-->
                       <b-button 
                       v-if="item[0].tspecial.valor > 0"
                       block 
                       squared 
                       class="button mb-2 mt-2 ml-3 mr-3"
                       :to="'promocion-especial/' + item[0].vehiculo_id +'/'+ item[0].marca +'/'+item[0].modelo"
                       >PROMO</b-button>
                     </b-row>
                  </b-col>
                </b-row>
                <br>
                <div class="cardetailtext mb-4">
                       <p class="cardetailtext" v-b-toggle="'collapsecar'+item[0].id">
                       <img src="/img/arrowdown.png" class="mr-2">
                       {{$t('fleet.fl4')}}
                       </p>
                </div>
                <b-collapse 
                v-bind:id="'collapsecar'+item[0].id"
                class="carcard"
                style=""
                >
                  <b-card class="rounded-0" style="background:#f3f3f3">
                   <b-row>
                     <b-col md>
                       <h3 class="cartitletext">{{$t('fleet.fl7')}}</h3>
                         <span v-if="$i18n==='es'" class="mr-1 carsubtitle">· {{item[0].equipamiento}} </span>
                         <span v-else class="mr-1 carsubtitle">· {{item[0].equipamiento_en}} </span> 
                        <!--  <span class="mr-1 carsubtitle">· Automático </span> 
                         <span class="mr-1 carsubtitle">· Aire acondicionado</span>  -->
                     </b-col>
                     <b-col md>
                        <!-- <h3 class="cartitletext">Detalles del precio</h3>
                        <br>
                        <p style="text-align:left;">TOTAL ESTIMADO
                          <span style="float:right;"> {{parseFloat(item.detalle.total).toFixed(2)}}*</span>
                        </p> -->
                        <br>
                        <div class="">
                        <h3 class="cartitletext">{{$t('fleet.fl8')}}</h3>
                        <p style="text-align:left;">
                          <!-- <span v-if="$i18n.locale==='es'">{{item.reserva.paquete}}</span>
                          <span v-else>per day</span> -->
                          <span style="float:right;">US$ {{parseFloat(item.detalle.tarifa).toFixed(2)}} </span>
                        </p>
                        <br>
                        <h3 class="cartitletext">{{$t('fleet.fl9')}}</h3>

                        <b-row v-if="item.detalle.cob_obligatoria != null">
                          <b-col  cols="8" >
                            <span class="float-left" v-if="$i18n.locale==='es'" v-show="item.detalle.cob_obligatoria.monto[0] > 0">{{item.detalle.cob_obligatoria.nombre[0]}}</span>
                            <span class="float-left" v-else v-show="item.detalle.cob_obligatoria.monto[0] > 0">Loss damage partial waiver</span>
                          </b-col>
                          <b-col>
                            <span class="float-right" v-show="item.detalle.cob_obligatoria.monto[0] > 0">US$ {{parseFloat(item.detalle.cob_obligatoria.monto[0]).toFixed(2)}}</span><br>
                          </b-col>
                        </b-row>

                        <b-row v-if="item.detalle.cob_obligatoria != null">
                          <b-col  cols="8" >
                            <span class="float-left" v-if="$i18n.locale==='es'" v-show="item.detalle.cob_obligatoria.monto[1] > 0">{{item.detalle.cob_obligatoria.nombre[1]}}</span>
                            <span class="float-left" v-else v-show="item.detalle.cob_obligatoria.monto[1] > 0">Third parties damage (mandatory)</span>
                          </b-col>
                          <b-col>
                            <span class="float-right" v-show="item.detalle.cob_obligatoria.monto[1] > 0">US$ {{parseFloat(item.detalle.cob_obligatoria.monto[1]).toFixed(2)}}</span>
                          </b-col>
                        </b-row>

                        <b-row>
                          <b-col  cols="8"  v-if="item.detalle.apo_fee > 0">
                            <span>{{$t('fleet.fl10')}}</span>
                          </b-col>
                          <b-col>
                            <span style="float:right;">US$ {{parseFloat(item.detalle.apo_fee).toFixed(2)}} </span>
                          </b-col>
                        </b-row>

                        <b-row>
                          <b-col  cols="8" >
                            <span>Subtotal</span>
                          </b-col>
                          <b-col>
                            <span style="float:right;">US$ {{parseFloat(item.detalle.subtotal).toFixed(2)}} </span>
                          </b-col>
                        </b-row>

                        <b-row>
                          <b-col  cols="8" >
                            <span>{{$t('fleet.fl11')}}</span>
                          </b-col>
                          <b-col>
                            <span style="float:right;">US$ {{parseFloat(item.detalle.itbm).toFixed(2)}} </span>
                          </b-col>
                        </b-row>
                        <hr>
                        <b-row>
                          <b-col  cols="8" >
                            <span>{{$t('fleet.fl12')}}</span>
                          </b-col>
                          <b-col>
                            <span style="float:right;">US$ {{parseFloat(item.detalle.total).toFixed(2)}} </span>
                          </b-col>
                        </b-row>

                        </div>
                     </b-col>
                   </b-row>
                   <!-- <div class="carsmalltext mt-3">
                     Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi, nesciunt eligendi maxime repellendus nostrum velit maiores laudantium eius ex, explicabo enim fugiat, obcaecati eos? Alias exercitationem blanditiis voluptatibus iste quae.
                   </div> -->
                  </b-card>
                </b-collapse>
                <!-- ////////// END MOBILE //////////// -->
                <!-- ////////////////////////////////// -->
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        </div>
      </div>
      <br><br>
     <!--  <pre>{{selected}}</pre> -->
        <!-- <pre>
        {{ precalculo }}
        </pre> -->
    </div>
</template>
<script>
import loader from '@/components/loader.vue'
import Carousel from '@/components/carousel_promos.vue'
import { mapState, mapActions }   from 'vuex'
import { useGtm } from '@gtm-support/vue2-gtm';
import '@/assets/styles/styles.css'
export default {
  components: {
    loader,
    Carousel
  },
    mounted () {
      if(this.procesoReserva == false)
      {
        this.$router.push({path:"/"})
      }
      this.view_Car_gtm()
    },
    name: 'fleetcomp',
    data(){
      return{
        slide: 0,
        sliding: null,
        back:'<',
        options: [ "Autos", "SUV", "Van", "Comercial", "Promo" ],
        selected: [],
				category: [],
				allselected:  ["Autos", "SUV", "Van", "Comercial"],
        options2: [
          { value: null, text: 'Articulo destacado' },
          { value: 'a', text: 'Precio de menor a mayor' },
          { value: 'b', text: 'Precio de mayor a menor' },
          ]
      }
    },
    computed: {
      //...mapState('reserva',['precalculo', 'procesoReserva', 'loader']), //borrar luego
      ...mapState('reservav2',['precalculo', 'procesoReserva', 'loader','data']),
    },
    methods: {
      //...mapActions('reserva', ['tercerPaso']), // borrar luego
      ...mapActions('reservav2', ['tercerPaso']),
      onSlideStart(slide) {
        this.sliding = true
      },
      onSlideEnd(slide) {
        this.sliding = false
      },
      paquetes(tarifa, dias)
      {
        let tarifaFormato =  tarifa * (dias -1)
        return tarifaFormato.toFixed(2)
      },

      select_Car_gtm(name, id, brand, category, price, index, transmision, capacidad, tipo){
        let gtm = useGtm();
        gtm.trackEvent({
              'event': 'select_item',        // GA4 native event
              'category' : 'ecommerce',      // Static data
              'action' : 'select_item',      // Static data
              'label': '652576',             // Dynamic data. item_id
              'list_name': 'Vehículos | Selecciona el tipo de vehículos', 
                                                // Dynamic data. List Name.
            //Enhanced Ecommerce - UA
              'ecommerce': {
                'currencyCode': 'USD',
                'click':{
                'actionField':{
             'list': 'Vehículos | Selecciona el tipo de vehículos'},
                'products': [
                 {
                   'name': name,
                   'id': id,
                   'brand': brand,
                   'category': category, 
                                                // Category/Category2/Category3
                   'list': 'Vehículos | Selecciona el tipo de vehículos',
                   'index': index,
                   'price': price,
                   'coupon': '',
                }]
               },
              
             }
        });
        /* second trigger */
          gtm.trackEvent({
             'event': 'checkout',
             'category' : 'ecommerce',  //Static data
             'action' : 'choose a vehicle class',      // Static data
             
            //Enhanced Ecommerce - UA
             'ecommerce': {
               'currencyCode': 'USD',
               'checkout':{ 
                   'actionField': {
                      'step': 3, 
                      'option': 'choose a vehicle class'
                      }
                           },
                     'products': [
                      {
                        'name': name,                                     //CD11
                        'id': id, 
                        'brand': brand,                               //CD15
                        'category': category, 
                                                     // Category/Category2/Category3
                        'list': 'Vehículos | Selecciona el tipo de vehículos',
                        'index': index,
                        'price': price,
                        'coupon': '',
                        'quantity': '1',
                  //Custom dimensions at product level
                              'transmission_type': transmision,                           //CD12
                              'number_of_passengers': capacidad,                   //CD19
                              'codigo_vehiculo': tipo,               //CD20
                     }]
                    },
            });
      },

      view_Car_gtm(){
        
        var obj2=[];
        var obj = this.precalculo
    
        var obj2 = obj.map((obj,i,a )=> ({
            
            name: obj[0].modelo,
            id: obj[0].id,
            brand: obj[0].marca,
            category: obj[0].categoria,
            list: 'Vehículos | Selecciona el tipo de vehículos',
            index: i,
            price: obj[0].valor,
            coupon: ''
        }))

        //console.log('view test', obj2)
      
        const gtm = useGtm();
        gtm.trackEvent({
            'event': 'view_item_list',        // GA4 native event
            'category' : 'ecommerce',         // Static data
            'action' : 'view_item_list',      // Static data
            'label': 'Vehículos | Selecciona el tipo de vehículos',
                                              // Dynamic data. List Name.
          //Enhanced Ecommerce - UA
            'ecommerce': {
              'currencyCode': 'USD',
              'impressions': obj2
               /* [
               {
                 'name': name,
                 'id': id,
                 'brand': brand,
                 'category': category, 
                                    // Category/Category2/Category3
                 'list': 'Vehículos | Selecciona el tipo de vehículos',
                 'index': index,
                 'price': price,
                 'coupon': '',
               }] */
             },
           });

          /* second trigger */
          /* gtm.trackEvent({
             'event': 'checkout',
             'category' : 'ecommerce',  //Static data
             'action' : 'choose a vehicle class',      // Static data
             
            //Enhanced Ecommerce - UA
             'ecommerce': {
               'currencyCode': 'USD',
               'checkout':{ 
                   'actionField': {
                      'step': 3, 
                      'option': 'choose a vehicle class'
                      }
                           },
                     'products': [
                      {
                        'name': name,                                     //CD11
                        'id': id, 
                        'brand': brand,                               //CD15
                        'category': category, 
                                                     // Category/Category2/Category3
                        'list': 'Vehículos | Selecciona el tipo de vehículos',
                        'index': index,
                        'price': price,
                        'coupon': '',
                        'quantity': '1',
                  //Custom dimensions at product level
                              'transmission_type': transmision,                           //CD12
                              'number_of_passengers': capacidad,                   //CD19
                              'codigo_vehiculo': tipo,               //CD20
                     }]
                    },
            }); */
                 
           
      }
    },
    watch: {

			selected: {
                handler: function(val, oldVal) {
				if(val.length>0){
					this.allselected.length = 0
					this.all = false
					
					console.log("watch", val)
				
				}else if(this.category.length==0){
					this.allselected = [ "Autos", "SUV", "Van", "Comercial" ];
				}
					
			   }
                
			},
			category: {
                handler: function(val, oldVal) {
				if(val.length>0){
					this.allselected.length = 0
					this.all = false
					console.log("watch", val)
				
				}else if(this.selected.length==0){
					this.allselected = [ "Autos", "SUV", "Van", "Comercial" ];
				}
					
			   }
                
			}/* ,
			all: {
                handler: function(val, oldVal) {
					if(val){
						this.selected.length = 0
						this.category.length = 0
						this.allselected = [ "Autos", "SUV", "Van", "Comercial" ];
						console.log("all watch",val )
					}
			   }
			} */
    },
}
</script>

<style  scoped>
@font-face {
    font-family: 'DIN 2014-ExraBold';
    src: url('../assets/fonts/DIN2014-ExtraBold.ttf');

}
@font-face {
    font-family: 'DIN 2014-Regular';
    src: url('../assets/fonts/DIN2014-Regular.ttf');
}
.carsimg{
  height: 100px;
  width: 130px;
}
.carcard{
  background:#f3f3f3 !important;
}
.cartitle{
   color: #181918; 
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 25px;
   font-weight: 400;
   height: 29px;
   line-height: 29.1667px;
}
.carsubtitle{
   color: #656565; 
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 14px;
   font-weight: 300;
   height: 19px;
   line-height: normal;
}
.carsmalltext{
   color: #656565; 
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 12px;
   font-weight: 300;
}
.cardetailtext{
   color: #169a5a; 
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 15px;
   font-weight: 600;
   text-decoration: none;
   cursor: pointer;
}
.cardetailtext:focus {
  outline: 2px solid #a4ceff !important;
}
.caricons{
   color: #656565 !important;
   height: 18px;
   width:  14px;
}
.buttonreserve{
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
  Color: #169A5A;
  font-size: 18px;
  font-weight: 600;
  Text-align: center;
  text-decoration: none !important;
  Background: #ffffff;
  Height: 64px;
  border: solid 2px #169A5A;
}
.buttonreserve:hover{
  Background:#169A5A;
  border: solid 2px #169A5A;
  text-decoration: none !important;
  Color: #ffffff;
}
.cartitletext{
  color: #181918; 
  font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
  font-size: 14px;
}
.supportside{
  background-color: rgb(235, 235, 235);
  
}
.listgroup{
  border-top: none;
  border-left: none;
  border-right: none;
}
.supporticons{
    height: 50px;
    width: 50px;
    margin-bottom: 15px;
    margin-top: 30px;
}
.titlesection{
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
   color: #333333;
   font-weight: 600;
   margin-bottom: 15px;
}
.titlesupp{
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 18px;
   color: #169a5a;
   font-weight: 600;
   margin-bottom: 15px;
}
.textsupp{
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 18px;
   color: #169a5a;
}
.wrapper {
    min-height: 100%;
    height: auto !important;
    margin: 0 auto -30px;
    padding: 0 0 30px 0px;   /* new padding */
}
.collapsing {
  transition: none !important;
}
.titlequestion{
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 32px;
   margin-top: 15px;
   margin-left: 15px;
   font-weight: 800;
   color: #181918;
}
.questions{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    margin-left: 32px;
    line-height: 40px;
    color: #169a5a;
    font-size: 17px;
    font-weight: 500;
    text-decoration: none;
    margin: 0px;
    padding: 0px;
}
.questions:hover {
  color: #006639 !important;
}
.questions:focus {
  outline: 2px solid #a4ceff !important;
}
.navlinks{
    border-bottom: solid 0.05px rgb(185, 185, 185);
    
}
.navtext{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #169a5a !important;
    font-size: 14px;
    font-weight: 300;
}
.navtext2{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #686e6b !important;
    font-size: 14px;
    font-weight: 300;
}
.filtertitle{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #333333 !important;
    font-size: 14px;
}
.button{
  font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
  Color: #FFFFFF;
  Size: 14px;
  letter-spacing: 0.9px;
  font-weight: 600;
  Text-align: center;
  Text-transform: uppercase;
  Background: #169A5A;
  Height: 33px;
  border: none;
}
.button:hover{
  Background:#006639;
}
.noline{
  text-decoration: none;
}

/* /////////// CHECKBOX //////////////  */
/* The customcheck */
.customcheck {
    display: block;
    position: relative;
    padding-left: 35px;
    padding-top: 5px;
    margin-bottom: 22px;
    font-size: 14px;
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    margin-left: -14px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* Hide the browser's default checkbox */
.customcheck input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* Create a custom checkbox */
.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 28px;
    width:  28px;
    background-color: rgb(255, 255, 255);
    border-radius: 0px;
    border: solid 2px #b8b8b8;
}

/* On mouse-over, add a grey background color */
.customcheck:hover input ~ .checkmark {
    background-color: #eee;
}

/* When the checkbox is checked, add a blue background */
.customcheck input:checked ~ .checkmark {
    background-color: #ffffff;
    border-radius: 0px;
    border: solid 3px #169a5a;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the checkmark when checked */
.customcheck input:checked ~ .checkmark:after {
    display: block;
}

/* Style the checkmark/indicator */
.customcheck .checkmark:after {
    left: 6px;
    top: 3px;
    width: 10px;
    height: 12px;
    border: solid 2px #169a5a;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}
.gb-color{
background-color: #169A5A !important;
}
 /* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .carou{
  margin-left: 2%;
  margin-right: 2%;
}
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .carou{
  margin-left: 2%;
  margin-right: 2%;
}
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .carou{
  margin-left: 2%;
  margin-right: 2%;
}
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .carou{
  margin-left: 10%;
  margin-right: 10%;
}
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
.carou{
  margin-left: 20%;
  margin-right: 20%;
}
} 
</style>

